

export default {
    name: "ContactCard",
    props: {
        result: {
            type: Object,
            required: true,
            imageSrc: {
                type: String,
                required: true,
            },
            imageAlt: {
                type: String,
                required: true,
            },
            contactName: {
                type: String,
                required: true,
            },
            contactTitle: {
                type: String,
                required: true,
            },
            quote: {
                type: String,
                required: true,
            },
            phone: {
                type: String,
                required: true,
            },
            email: {
                type: String,
                required: true,
            },
            url: {
                type: String,
                required: true,
            },
        }
    },
    setup(){
        // enabling store in component

        return {
     
        }
    }
}